module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-26.8708d0a1.png";